var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"mh-app-component",attrs:{"id":"app"}},[_c('router-view'),_c('LoadingOverlay'),_c('NotificationHandler')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }